const ApiStore = require("stores/abstract/ApiStore");
const env = require("services/env");
const router = require("services/router");
const moment = require("moment");
const axios = require("axios");
const assign = require("object-assign");

class NotificationsStore extends ApiStore {

	read(notifications) {
		return axios
			.post(router.route("api.notifications.read"), {
				ids: notifications.map(notification => notification.id)
			})
			.then(response => {
				this.metadata = assign(this.metadata, response.data.metadata);
				return this.replace(response.data.collection);
			});
	}

}

const store = new NotificationsStore(
	env.get("stores.notifications.collection", []),
	env.get("stores.notifications.constraints", []),
	env.get("stores.notifications.metadata", []),
	{
		endpoint: router.route("api.notifications.index")
	}
);

// Hook to collection change to always keep the models sorted chronological
store.collectionChange.pipe(collection => collection.sort((a, b) => {
	return moment(a.created_at).isAfter(moment(b.created_at)) ? -1 : 1;
}));

module.exports = store;



// WEBPACK FOOTER //
// ./resources/js/stores/NotificationsStore.js